import * as React from "react";
import { Form, Input, Button } from "antd";
import { I18N_NS } from "Config/i18n";
import { useTranslation } from "react-i18next";
import { API } from "General/API";
import { API_URL } from "General/APIEndpoints";
import { ButtonsRow } from "Components/Form/ButtonsRow";
import { notificationSuccess } from "utils/libHelpers/AntdNotification";
import { Spin } from "Components/General/Spin";
import { useNavigate } from "react-router";

export const EmailSignature = () => {
  const [loading, setLoading] = React.useState(false);
  const { t } = useTranslation(I18N_NS.ADMIN);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const goBack = () => navigate(-1);

  const fetchSignature = React.useCallback(async () => {
    try {
      setLoading(true);
      const response: API_StringData = await API.getData(API_URL.ADMIN.getEmailSignature());
      form.setFieldsValue({ signature: response.stringValue || "" });
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  }, [form]);
  const onSubmit = async (values) => {
    try {
      setLoading(true);
      await API.editData(API_URL.ADMIN.updateEmailSignature(), values.signature);
      notificationSuccess(t("Success"), t("Signature saved"));
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchSignature();
  }, [fetchSignature]);

  return (
    <Spin spinning={loading}>
      <div className="g-card">
        <Form onFinish={onSubmit} form={form} layout="vertical">
          <Form.Item label={t("Signature for emails from sys admins")} name="signature">
            <Input.TextArea placeholder={t("Signature for emails from sys admins")} />
          </Form.Item>
          <ButtonsRow justify="space-between">
            <Button onClick={goBack}>{t("Cancel")}</Button>
            <Button type="primary" htmlType="submit">
              {t("Save")}
            </Button>
          </ButtonsRow>
        </Form>
      </div>
    </Spin>
  );
};
